<template>
  <div class="container">
    <div class="w">
      <div class="ts">
        <marquee
          ><span>
            智慧二手车市场：通过大数据+互联网为基础，推动以人（消费者）为中心的商业重构，让消费者在合适时间买到合适的产品，让市场管理智能化，客户管理智慧化，真正赋能场内车商，促进加速商品流转。
          </span></marquee
        >
      </div>
    </div>
    <div class="content">
      <div class="w">
        <div class="title">
          <h3>品质保证</h3>
          <p>严格的质量把关，为您铸就放心产品</p>
        </div>
        <div class="warp1">
          <div>
            <img src="../../assets/ys1.png" alt="" />
            <p class="tlt">科技</p>
            <p>
              科技与人的结合，减少人力成本的投入，提升效益产出
            </p>
          </div>
          <div>
            <img src="../../assets/ys2.png" alt="" />
            <p class="tlt">商业</p>
            <p>
              汽车文化与商业文化的结合达到互惠共赢
            </p>
          </div>
          <div>
            <img src="../../assets/ys3.png" alt="" />
            <p class="tlt">互联网+</p>
            <p>
              互联网+，车辆管理数字化标准化，提升管理效率
            </p>
          </div>
          <div>
            <img src="../../assets/ys4.png" alt="" />
            <p class="tlt">O2O</p>
            <p>
              线上线下融合，智能化运营二手车市场
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="content" style="background-color:#f2f3f4;">
      <div class="w">
        <div class="title">
          <h3>技术文章</h3>
          <p>Technical articles</p>
        </div>
        <div class="warp3" v-if="articleList.length > 0">
          <div class="news-img" @click="toDetail(articleList[0].id)">
            <img :src="articleList[0].coverUrl" alt="" />
            <div class="news-con">
              <p>{{ articleList[0].title }}</p>
              <span> {{ articleList[0].description }}</span>
              <em>{{ articleList[0].createTime }}</em>
            </div>
          </div>
          <div class="news-list">
            <template v-for="(item, index) in articleList">
              <div class="news-box" :key="index" v-if="index > 0" @click="toDetail(item.id)">
                <div class="news-time">
                  <p>{{ item.year }}</p>
                  <span>{{ item.day }}</span>
                </div>
                <div class="news-con">
                  <p>{{ item.title }}</p>
                  <span>{{ item.description }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="w">
        <div class="title">
          <h3>产品展示</h3>
          <p>Products Classification</p>
        </div>
        <div class="warp2">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="products-box">
                <div class="products-img">
                  <img src="../../assets/cp/CRM.png" alt="" />
                </div>
                <span>CRM</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="products-box">
                <div class="products-img">
                  <img src="../../assets/cp/ERP.png" alt="" />
                </div>
                <span>ERP</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="products-box">
                <div class="products-img">
                  <img src="../../assets/cp/大数据分析.png" alt="" />
                </div>
                <span>管车助手</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="products-box">
                <div class="products-img">
                  <img src="../../assets/cp/市场助手.png" alt="" />
                </div>
                <span>市场帮手</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="products-box">
                <div class="products-img">
                  <img src="../../assets/cp/待办派单.png" alt="" />
                </div>
                <span>待办派单</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="products-box">
                <div class="products-img">
                  <img src="../../assets/cp/智能过户.png" alt="" />
                </div>
                <span>智能过户</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="products-box">
                <div class="products-img">
                  <img src="../../assets/cp/管车助手.png" alt="" />
                </div>
                <span>管车助手</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="products-box">
                <div class="products-img">
                  <img src="../../assets/cp/金融风控.png" alt="" />
                </div>
                <span>金融风控</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="content bg">
      <div class="w">
        <div class="title">
          <h3>关于我们</h3>
          <p>About us</p>
        </div>
        <div class="warp4">
          <img class="about-img" src="https://ossimage.xiaochejun.cn/images/web/pic_16224395770172615.jpg" alt="" />
          <div class="about-con">
            <p>
              南京知车君网络科技有限公司，成立于2016年底，创始人深耕二手车市场信息化升级改造十余载为二车市场实现品牌化运营、让车商好卖车、好收车、让消费者敢买。助力二手车市场升级转化新模式，管理标准统一、线上线下融合、二手车市场互联互通，最终完成新型智慧化二手车交易市场。
            </p>
            <span class="btn-more1" @click="lookMore">查看更多 >></span>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="w">
        <div class="title">
          <h3>成功案例</h3>
          <p>Case</p>
        </div>
        <div class="warp5">
          <el-row :gutter="30" style="margin-bottom:30px;">
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/武汉市爱之家汽车服务有限公司.png" alt="" />
                <span>武汉市爱之家汽车服务有限公司</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/湖南中南二手车工程机械交易管理有限公司.jpg" alt="" />
                <span>湖南中南二手车工程机械交易管理有限公司</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/浙江途众汽贸控股有限公司.png" alt="" />
                <span>浙江途众汽贸控股有限公司</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/苏州恩加壹汽车服务有限公司.jpg" alt="" />
                <span>苏州恩加壹汽车服务有限公司</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/枣庄中安旧机动车交易市场有限公司.jpg" alt="" />
                <span>枣庄中安旧机动车交易市场有限公司</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/南京大公二手车交易中心有限公司.jpg" alt="" />
                <span>南京大公二手车交易中心有限公司</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="30" style="margin-bottom:30px;">
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/太原旧机动车交易中心（有限公司）.jpg" alt="" />
                <span>太原旧机动车交易中心（有限公司）</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/南宁新畅行汽车市场管理有限公司.jpg" alt="" />
                <span>南宁新畅行汽车市场管理有限公司</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/沈阳好车芝嘛科技有限公司.png" alt="" />
                <span>沈阳好车芝嘛科技有限公司</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/新疆天汇华尚二手车交易有限公司.jpg" alt="" />
                <span>新疆天汇华尚二手车交易有限公司</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/九江二手车市场有限公司.png" alt="" />
                <span>九江二手车市场有限公司</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="logo-box">
                <img src="../../assets/logo/南通三六五二手车交易市场有限公司.jpg" alt="" />
                <span>南通三六五二手车交易市场有限公司</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { articleList } from '@/api/article'
export default {
  data() {
    return {
      listQuery: {
        articleType: 1,
        pageNo: 1,
        pageSize: 4
      },
      articleList: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const { data } = await articleList(this.listQuery)
      data.page.rows.forEach(item => {
        item.year = item.createTime.substring(0, 4)
        item.day = item.createTime.substring(5, 10)
      })
      this.articleList = data.page.rows
    },
    toDetail(id) {
      this.$router.push({
        path: '/index/article/article-detail?id=' + id
      })
    },
    // 查看更多
    lookMore() {
      this.$router.push({
        path: '/index/about'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ts {
  background-color: #02328d;
  color: #fff;
  line-height: 40px;
  height: 40px;
  font-size: 16px;
  position: relative;
  top: -10px;
  left: 0;
  z-index: 9;
  padding: 0 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content {
  padding: 40px 0;
  .title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h3 {
      height: 30px;
      line-height: 30px;
      font-size: 24px;
    }
    p {
      height: 40px;
      line-height: 40px;
      color: #888;
    }
  }
}

.warp1 {
  padding-top: 40px;
  display: flex;
  div {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      background-color: #eee;
    }
    p {
      text-align: center;
      color: #999;
      padding: 0 20px;
      font-size: 14px;
    }
    .tlt {
      margin-top: 20px;
      margin-bottom: 5px;
      font-size: 20px;
      color: #2a333c;
    }
  }
}

.warp2 {
  margin-top: 40px;
  .products-box {
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .products-img {
      width: 80%;
      height: 80px;
      display: flex;
      justify-content: center;
      img {
        height: 100%;
        object-fit: contain;
      }
    }
  }
}

.warp3 {
  padding-top: 40px;
  display: flex;
  justify-content: space-between;
  .news-img {
    width: 49%;
    img {
      height: 200px;
      width: 100%;
      vertical-align: middle;
      object-fit: cover;
    }
    .news-con {
      padding: 20px;
      display: flex;
      flex-direction: column;
      background-color: #fff;
      p {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 18px;
        color: #515671;
        font-weight: 700;
        height: 50px;
        line-height: 50px;
      }
      span {
        display: block;
        font-size: 14px;
        color: #999;
        line-height: 22px;
        background: #fff;
        height: 66px;
        display: -webkit-box; /*将对象转为弹性盒模型展示*/
        -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
        -webkit-line-clamp: 3; /*限制文本行数*/
        overflow: hidden; /*超出隐藏*/
      }
      em {
        display: block;
        font-size: 14px;
        color: #c6c6c6;
        padding-top: 10px;
        background: #fff;
      }
    }
  }
  .news-list {
    width: 49%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .news-box {
      display: flex;
      width: 100%;
      background-color: #fff;
      padding: 24px;
      .news-time {
        width: 90px;
        text-align: center;
        background: #cacaca;
        padding: 10px 0;
        border-radius: 4px 0 4px 0;
        margin-right: 24px;
        p {
          font-size: 24px;
          font-weight: 700;
          color: #fff;
        }
        span {
          font-size: 14px;
          color: #fff;
        }
      }
      .news-con {
        flex: 1;
        p {
          font-size: 15px;
          font-weight: 700;
          color: #515671;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          display: block;
          font-size: 14px;
          color: #999;
          line-height: 22px;
          padding-top: 5px;
          height: 46px;
          overflow: hidden;
        }
      }
    }
  }
}
.bg {
  background: url(../../assets/bg.jpg) no-repeat;
  .title {
    h3 {
      color: #fff;
    }
    p {
      color: #fff;
    }
  }
}
.warp4 {
  margin-top: 40px;
  padding: 20px 0;
  display: flex;
  justify-content: flex-end;
  background-color: #fff;
  position: relative;
  .about-img {
    position: absolute;
    left: 20px;
    bottom: 20px;
    width: 38%;
    height: 280px;
    object-fit: cover;
  }
  .about-con {
    width: 60%;
    height: 240px;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    p {
      font-size: 14px;
      color: #fff;
      color: #666;
      line-height: 27px;
      height: 158px;
      overflow: hidden;
      text-indent: 2em;
    }
    .btn-more1 {
      border: 1px solid;
      color: #02328d;
      display: block;
      width: 110px;
      text-align: center;
      -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1) 0ms;
      transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1) 0ms;
      height: 30px;
      line-height: 30px;
    }
  }
}
.warp5 {
  padding-top: 40px;
  .logo-box {
    height: 120px;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    img {
      width: 80%;
      height: 60%;
      object-fit: contain;
    }
    span {
      color: #888;
      text-align: center;
      font-size: 12px;
      height: 30px;
      padding: 0 10px;
    }
  }
}
</style>
